import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, FieldGroup, LinkButton, TextField } from '../../../components';
import { useStore } from '../../../store';
import { onSuccess } from '../../../utils/errors';
import CenteredForm from '../components/CenteredForm';
import LoginLayout from '../components/LoginLayout';

export default observer(function ResetPasswordPage() {
  const { authStore } = useStore();
  const [reset] = useState(authStore.createResetPassword());

  async function onResetPassword() {
    await reset.reset();
    onSuccess(`Password recovery link was sent to ${reset.email}`);
  }

  return (
    <LoginLayout>
      <CenteredForm onSubmit={onResetPassword}>
        <TextField
          autoFocus
          errorText={reset.errors.email}
          label="Email"
          name="email"
          onBlur={reset.handleBlur}
          onChange={reset.handleChange}
          value={reset.email}
        />

        <FieldGroup sx={{ mt: 3 }} textAlign="center">
          <Button
            disabled={!reset.isValid}
            disabledTooltip={reset.allErrorsAsStrings}
            onClick={onResetPassword}
            type="submit"
          >
            Send recovery link
          </Button>
          <LinkButton to="/login" type="secondary">
            Log in
          </LinkButton>
        </FieldGroup>
      </CenteredForm>
    </LoginLayout>
  );
});
